import { render, staticRenderFns } from "./show-msg.vue?vue&type=template&id=dbbff8c4&"
import script from "./show-msg.vue?vue&type=script&lang=js&"
export * from "./show-msg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports